<div
    class="font-inter text-color w-full h-full"
    [ngClass]="{
        'bg-[linear-gradient(359deg,_#FFF_83.33%,_var(--latte-50,_#F9F5F0)_99.08%)]': dynamicPanel,
    }">
    <div class="w-full h-full p-4 flex flex-col">
        <div class="flex flex-col justify-start items-center">
            @if (!dynamicPanel) {
                <p-breadcrumb
                    class="self-start"
                    [model]="breadcrumbItems"
                    [home]="{ icon: 'pi pi-home', routerLink: '/' }"></p-breadcrumb>
            }

            <div class="w-full text-left font-semibold text-color mb-4">Favorites schedule</div>
            <div
                class="w-full flex items-center"
                [ngClass]="{
                    'justify-between gap-1': dynamicPanel,
                    'justify-center gap-2': !dynamicPanel,
                }">
                @if (dynamicPanel) {
                    <p-select
                        size="small"
                        class="flex-1 h-8"
                        styleClass="w-full"
                        [options]="durationOptions"
                        optionLabel="labelDropdown"
                        [ngModel]="selectedDurationOption.value"
                        optionValue="value"
                        (onChange)="onDurationDropDownChanged($event)" />
                } @else {
                    <p-select-button
                        class="w-[235px] h-10"
                        styleClass="w-full"
                        [options]="durationOptions"
                        optionLabel="labelButton"
                        [ngModel]="selectedDurationOption.value"
                        optionValue="value"
                        [allowEmpty]="false"
                        (onChange)="onDurationDropDownChanged($event)">
                        <ng-template #item let-item>
                            <div class="font-medium text-12 leading-[normal]">{{
                                item.labelButton
                            }}</div>
                        </ng-template>
                    </p-select-button>
                }
                <div
                    class="h-8 flex justify-between items-center rounded-lg border border-[#e8dccd] bg-white px-2"
                    [ngClass]="{ 'h-8': dynamicPanel, 'h-10': !dynamicPanel }">
                    <label
                        class="text-left text-color leadning-[normal] mr-1"
                        [ngClass]="{
                            'text-[12.25px] font-light': dynamicPanel,
                            'text-12 leadning-[normal] font-medium': !dynamicPanel,
                        }"
                        for="quitemode"
                        >Quiet</label
                    >
                    <p-toggleSwitch
                        #quitemode
                        (onChange)="onQuietModeToggleSwtichChange($event)"
                        class="flex"
                        [(ngModel)]="selectedQuietMode" />
                </div>
            </div>
        </div>

        @if (filteredFavoritesSessionList.length > 0) {
            <div class="h-[calc(100%_-_100px)] mt-4">
                <p-scrollpanel [style]="{ width: '100%', height: '100%' }">
                    <div
                        class="w-full flex flex-col justify-start"
                        [ngClass]="{
                            'items-start': dynamicPanel,
                            'items-center': !dynamicPanel,
                        }">
                        <div
                            class="flex flex-col items-center justify-start !mb-5 relative"
                            [ngClass]="{
                                'w-full': dynamicPanel,
                                'w-[320px]': !dynamicPanel,
                            }"
                            *ngFor="let day of filteredFavoritesSessionList; let i = index">
                            <div
                                #dayLabel
                                class="text-13 text-color font-inter font-semibold sticky text-left top-0 z-[300] w-full bg-white !pb-4 pt-4"
                                >{{ day.dayLabel }}</div
                            >

                            <div
                                class="w-full flex flex-col justify-start items-center relative !mb-6 last:!mb-0"
                                *ngFor="let time of day.times">
                                <div
                                    #timeLabel
                                    class="border-0 border-l-[3px] border-l-[#E8DCCD] w-full text-12 leading-[normal] text-color font-inter text-left font-semibold sticky top-11 z-[200] bg-white shadow-fmscroll-top px-2 py-1"
                                    >{{ time.timeLabel }}</div
                                >

                                <div class="w-full flex flex-col !mt-4 gap-5 pl-5">
                                    <!-- 25 minutes list -->
                                    <div
                                        *ngIf="time.sessions25.length > 0"
                                        class="w-full flex flex-col items-center justify-start h-screen max-h-max">
                                        <div
                                            class="w-full flex flex-row items-center justify-start">
                                            <p-divider
                                                align="center"
                                                type="solid"
                                                layout="vertical">
                                                <span class="text-11 text-color font-medium"
                                                    >25m</span
                                                >
                                            </p-divider>

                                            <div
                                                class="flex-1 flex flex-col items-center justify-center gap-3">
                                                <div
                                                    class="w-full flex flex-row justify-between items-center"
                                                    *ngFor="let session of time.sessions25">
                                                    <fm-availability-list-item
                                                        [ngClass]="{
                                                            'w-[140px] lg:w-[160px] xl:w-[180px]':
                                                                dynamicPanel,
                                                            'w-[272px]': !dynamicPanel,
                                                        }"
                                                        [externalId]="session.externalId"
                                                        [sessionTime]="session.sessionTime"
                                                        [sessionDuration]="session.sessionDuration"
                                                        [sessionState]="session.sessionState"
                                                        [durationLabel]="
                                                            session.sessionDurationLabel
                                                        "
                                                        [sessionTimeLabel]="session.timeLabel"
                                                        [sessionActivityType]="session.activityType"
                                                        [booked]="session.confirmed"
                                                        [selected]="
                                                            session.sessionTime ==
                                                                selectedSession &&
                                                            session.partnerUserId == selectedUserId
                                                        "
                                                        [disable]="disableBookSessions"
                                                        [userId]="session.partnerUserId"
                                                        [displayName]="session.partnerDisplayName"
                                                        [profileSlug]="session.partnerProfileSlug"
                                                        [profilePhoto]="session.profilePhoto"
                                                        [saved]="session.saved"
                                                        [bookingComplete]="session.actionComplete"
                                                        [partnerQuietMode]="
                                                            session.partnerPreferences.quietMode
                                                                .value
                                                        "
                                                        [dynamicPanel]="dynamicPanel"
                                                        (onCancelSession)="cancelSession($event)"
                                                        (onBookSession)="bookSession($event)"
                                                        (onSelectSession)="
                                                            selectSession($event)
                                                        "></fm-availability-list-item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 50 minutes list -->
                                    <div
                                        *ngIf="time.sessions50.length > 0"
                                        class="w-full flex flex-col items-center justify-start h-screen max-h-max">
                                        <div
                                            class="w-full flex flex-row items-center justify-start">
                                            <p-divider
                                                align="center"
                                                type="solid"
                                                layout="vertical">
                                                <span class="text-11 text-color font-medium"
                                                    >50m</span
                                                >
                                            </p-divider>

                                            <div
                                                class="flex-1 flex flex-col items-center justify-center gap-3">
                                                <div
                                                    class="w-full flex flex-row justify-between items-center"
                                                    *ngFor="let session of time.sessions50">
                                                    <fm-availability-list-item
                                                        [ngClass]="{
                                                            'w-[140px] lg:w-[160px] xl:w-[180px]':
                                                                dynamicPanel,
                                                            'w-[272px]': !dynamicPanel,
                                                        }"
                                                        [externalId]="session.externalId"
                                                        [sessionTime]="session.sessionTime"
                                                        [sessionDuration]="session.sessionDuration"
                                                        [sessionState]="session.sessionState"
                                                        [durationLabel]="
                                                            session.sessionDurationLabel
                                                        "
                                                        [sessionTimeLabel]="session.timeLabel"
                                                        [sessionActivityType]="session.activityType"
                                                        [booked]="session.confirmed"
                                                        [selected]="
                                                            session.sessionTime ==
                                                                selectedSession &&
                                                            session.partnerUserId == selectedUserId
                                                        "
                                                        [disable]="disableBookSessions"
                                                        [userId]="session.partnerUserId"
                                                        [displayName]="session.partnerDisplayName"
                                                        [profileSlug]="session.partnerProfileSlug"
                                                        [profilePhoto]="session.profilePhoto"
                                                        [saved]="session.saved"
                                                        [bookingComplete]="session.actionComplete"
                                                        [partnerQuietMode]="
                                                            session.partnerPreferences.quietMode
                                                                .value
                                                        "
                                                        [dynamicPanel]="dynamicPanel"
                                                        (onCancelSession)="cancelSession($event)"
                                                        (onBookSession)="bookSession($event)"
                                                        (onSelectSession)="
                                                            selectSession($event)
                                                        "></fm-availability-list-item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 75 minutes list -->
                                    <div
                                        *ngIf="time.sessions75.length > 0"
                                        class="w-full flex flex-col items-center justify-start h-screen max-h-max">
                                        <div
                                            class="w-full flex flex-row items-center justify-start">
                                            <p-divider
                                                align="center"
                                                type="solid"
                                                layout="vertical">
                                                <span class="text-11 text-color font-medium"
                                                    >75m</span
                                                >
                                            </p-divider>

                                            <div
                                                class="flex-1 flex flex-col items-center justify-center gap-3">
                                                <div
                                                    class="w-full flex flex-row justify-between items-center"
                                                    *ngFor="let session of time.sessions75">
                                                    <fm-availability-list-item
                                                        [ngClass]="{
                                                            'w-[140px] lg:w-[160px] xl:w-[180px]':
                                                                dynamicPanel,
                                                            'w-[272px]': !dynamicPanel,
                                                        }"
                                                        [externalId]="session.externalId"
                                                        [sessionTime]="session.sessionTime"
                                                        [sessionDuration]="session.sessionDuration"
                                                        [sessionState]="session.sessionState"
                                                        [durationLabel]="
                                                            session.sessionDurationLabel
                                                        "
                                                        [sessionTimeLabel]="session.timeLabel"
                                                        [sessionActivityType]="session.activityType"
                                                        [booked]="session.confirmed"
                                                        [selected]="
                                                            session.sessionTime ==
                                                                selectedSession &&
                                                            session.partnerUserId == selectedUserId
                                                        "
                                                        [disable]="disableBookSessions"
                                                        [userId]="session.partnerUserId"
                                                        [displayName]="session.partnerDisplayName"
                                                        [profileSlug]="session.partnerProfileSlug"
                                                        [profilePhoto]="session.profilePhoto"
                                                        [saved]="session.saved"
                                                        [bookingComplete]="session.actionComplete"
                                                        [partnerQuietMode]="
                                                            session.partnerPreferences.quietMode
                                                                .value
                                                        "
                                                        [dynamicPanel]="dynamicPanel"
                                                        (onCancelSession)="cancelSession($event)"
                                                        (onBookSession)="bookSession($event)"
                                                        (onSelectSession)="
                                                            selectSession($event)
                                                        "></fm-availability-list-item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="font-inter text-muted-color font-medium text-12-16 w-full text-center !pb-2"
                        >Showing sessions scheduled over<br />
                        the next two weeks.</div
                    >
                    <div
                        class="w-full ml-auto mr-auto h-10px min-h-[10px] bg-white sticky bottom-0 z-[900] !pb-6 shadow-fmscroll-bottom"></div>
                </p-scrollpanel>
            </div>
        } @else {
            <div class="w-full h-[calc(100%_-_153px)] mt-4">
                <div
                    class="h-full xxxh-[calc(100vh_-_309px)] w-full flex flex-col items-center justify-start relative">
                    <!-- Loading state -->
                    <!-- <app-loading-indicator
                            *ngIf="listContentState == 'loading'" 
                            class="mt-32"></app-loading-indicator> -->
                    <!-- No Favorites -->
                    <div *ngIf="listContentState == 'noFavorites'" class="error-text mt-20">
                        <div class="flex flex-col justify-start items-center gap-5">
                            <fa-icon
                                class="text-2xl text-bluegrey"
                                [icon]="faCalendarStar"></fa-icon>
                            <div class="text-sm text-bluegrey font-avenir">
                                Sessions booked by your Favorites<br />
                                appear here, but looks like you<br />
                                haven’t Favorited anyone yet.</div
                            >
                            <div
                                ><a
                                    target="_blank"
                                    href="http://support.focusmate.com/en/articles/6365663-about-favorites"
                                    class="text-sm text-blurple font-avenir no-underline"
                                    >Learn more about Favorite Partners</a
                                ></div
                            >
                        </div>
                    </div>
                    <!-- No sessions available -->
                    <div *ngIf="listContentState == 'emptyList'" class="error-text mt-20 mb-[10px]">
                        <div class="flex flex-col justify-start items-center gap-5">
                            <fa-icon
                                class="text-2xl text-bluegrey"
                                [icon]="faCalendarExclamation"></fa-icon>
                            <div class="text-sm text-bluegrey font-avenir">
                                Hmm...none of your Favorites have<br />
                                any sessions scheduled in the next<br />
                                couple of weeks.</div
                            >
                            <div
                                ><a
                                    routerLink="/dashboard"
                                    class="text-sm text-blurple font-avenir no-underline"
                                    >Let’s book with someone else on<br />
                                    the calendar?</a
                                ></div
                            >
                        </div>
                    </div>
                    <!-- Empty for the selected duration -->
                    <div
                        *ngIf="listContentState == 'emptyForSelectedDuration'"
                        class="error-text mt-20 mb-[10px]">
                        <div class="flex flex-col justify-start items-center gap-5">
                            <div class="text-sm text-bluegrey font-avenir">
                                No sessions available at the moment!</div
                            >
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
